import React, { Component } from 'react';
import { graphql } from 'react-relay';
import CsatByAnswerToOtherQuestionBarChart from '../../../../components/CsatByAnswerToOtherQuestionBarChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query CsatByAnswerToOtherQuestionWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $otherQuestionMongoId: ID
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
            ) {
              count
              ...CsatByAnswerToOtherQuestionBarChart_answersReport
            }
          }
        }
      }
    }
  `,
  (props) => {
    return {
      otherQuestionMongoId: props.widget.config.sliceByQuestion,
    };
  },
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({ hideFooter: true, subtitleMessageId: 'byOption' })
class CsatByAnswerToOtherQuestionWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <CsatByAnswerToOtherQuestionBarChart
        answersReport={question.answersReport}
        height={this.props.bodyHeight - 20}
        width={this.props.width}
        uniqueId={widget.id}
      />
    );
  }
}

export default CsatByAnswerToOtherQuestionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByAnswerToOtherQuestionWidget/CsatByAnswerToOtherQuestionWidget.js